export function OutlineElevatorIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0784 3H5.92C4.85961 3 4 3.85961 4 4.92V19.08C4 20.1404 4.85961 21 5.92 21H18.0784C19.1388 21 19.9984 20.1404 19.9984 19.08V4.92C19.9984 3.85961 19.1388 3 18.0784 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00171 9.05859V18.2506"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path d="M6.70239 9.73115L9.00159 5.75195L11.296 9.73115H6.70239Z" fill={fill} />
      <path
        d="M15.0017 14.944V5.75195"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path d="M17.296 14.2715L15.0016 18.2507L12.7024 14.2715H17.296Z" fill={fill} />
    </svg>
  );
}
